
<template>
  <div class="atividades-rfilancamentos ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="3">
          <label for="select-filial-lin">Filial</label>
          <multiselect
            id="selecao-filial-lin"
            v-model="value_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-situacao">Situação</label>
          <multiselect
            id="selecao-situcao-sol"
            v-model="value_situacao"
            required
            :options="situacoes"
            :multiple="true"
            :taggable="true"
            @close="loadFuncionarios()"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a situação"
            label="situacao"
            track-by="situacao"
            name="situacao"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <LoadingModal v-if="isLoading" />

        <b-col cols="3">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro / Versão"
          ></b-form-input>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            block
            class="mt-2 mr-2"
            v-b-modal.ModaleditarFuncionario
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      small
      hover
      striped
      sticky-header="762px"
      :items="itemsFiltered"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="putFunc(data.item)"
          title="Editar Funcionário"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.ModaleditarFuncionario
        >
          <i class="fa fa-pencil"></i>
        </b-button>
      </template>
    </b-table>
    <b-pagination
      size="xl"
      v-model="page"
      :total-rows="count"
      :per-page="limitfunc"
    ></b-pagination>

    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <div>
      <b-modal
        id="ModaleditarFuncionario"
        cancel-title="Fechar"
        ok-title="Gravar"
        @ok="postFuncionarios()"
        @cancel="reset()"
        @close="reset()"
        hide-footer
        size="xl"
        title="Cadastro de funcionário"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="6">
              <label for="input-filial">Empresa</label>
              <div>
                <b-form-select
                  id="fun-empresa"
                  v-model="funcionario.id_empresa"
                  required
                  :options="empresas"
                  class="mb-3"
                  text-field="empresa"
                  @change="loadFiliais()"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-filial">Filial</label>
              <div>
                <b-form-select
                  id="fun-filial"
                  v-model="funcionario.id_filial_erp"
                  required
                  :options="filiais"
                  class="mb-3"
                  text-field="filial"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="1" class="mb-2">
              <label for="input-live">Versão</label>
              <b-form-input
                v-model="funcionario.versao_app"
                readonly
                placeholder="ND"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mb-2">
              <label for="input-live">Id_funcionario_erp</label>
              <b-form-input
                v-model="funcionario.id_funcionario_erp"
                readonly
                placeholder="id_linha_erp"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-2 pr-4">
              <b-form-group label="" label-for="funcionario-foto">
                <b-img
                  class="custom-image mb-2"
                  v-bind="mainProps"
                  rounded
                  alt="Foto"
                  :src="funcionario.foto_url"
                  height="157"
                  width="131"
                >
                </b-img>
              </b-form-group>
            </b-col>

            <b-col cols="2" class="mb-2 mt-6">
              <label for="input-registro">REGISTRO</label>
              <b-form-input
                v-model="funcionario.registro"
                required
                placeholder="Registro"
                v-b-tooltip.hover
                title="Digite o registro do funcionário"
              ></b-form-input>
            </b-col>

            <b-col cols="5" class="mb-2">
              <label for="input-nome">Nome</label>
              <b-form-input
                v-model="funcionario.nome_completo"
                required
                placeholder="Nome"
                v-b-tooltip.hover
                title="Digite o nome do funcionário"
              ></b-form-input>
            </b-col>

            <b-col cols="3">
              <label for="input-funcao">Função</label>
              <div>
                <b-form-select
                  v-model="funcionario.id_funcao_erp"
                  required
                  :options="funcoes"
                  class="mb-3"
                  text-field="funcao"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-live">CPF</label>
              <b-form-input
                id="gar_ts"
                v-model="funcionario.cpf"
                required
                placeholder=""
                v-b-tooltip.hover
                title="Digite o cpf do funcionário"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">CELULAR</label>
              <b-form-input
                id="tp_ts"
                v-model="funcionario.celular"
                required
                placeholder=""
                v-b-tooltip.hover
                title="Digite o celular do funcionário"
              ></b-form-input>
            </b-col>

            <b-col cols="4">
              <label for="input-live">E-MAIL</label>
              <b-form-input
                id="ts_tp"
                v-model="funcionario.email"
                required
                placeholder=""
                v-b-tooltip.hover
                title="Digite o e-mail do funcionário"
              ></b-form-input>
            </b-col>

            <b-col cols="3">
              <label for="input-pis">PIS</label>
              <b-form-input
                id="tp_gar"
                v-model="funcionario.pis"
                required
                placeholder=""
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-2 mb-2">
            <b-col cols="3">
              <label for="input-admissao">DT NASCIMENTO</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="funcionario.dt_nascimento"
                required
                placeholder="Data de nascimento"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="3">
              <label for="input-admissao">DT ADMISSÃO</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="funcionario.dt_admissao"
                required
                placeholder="Data de admissão"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="3">
              <label for="input-admissao">DT DEMISSÃO</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="funcionario.dt_demissao"
                required
                placeholder="Data de demissao"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="3">
              <label for="input-status">SITUAÇÃO</label>
              <div>
                <b-form-select
                  v-model="funcionario.id_situacao"
                  required
                  :options="situacoes"
                  class="mb-3"
                  text-field="situacao"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="3">
              <label for="input-live">DATA CADASTRO</label>
              <b-input-group-text>{{
                moment(funcionario.dt_cadastro)
                  .format("DD/MM/YYYY HH:mm")
                  .replace("Data inválida", "-")
              }}</b-input-group-text>
            </b-col>

            <b-col cols="3">
              <label for="input-live">DATA ALTERAÇÃO</label>
              <b-input-group-text>
                <template v-if="funcionario.dt_alteracao">
                  {{
                    moment(funcionario.dt_alteracao)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-") +
                    (funcionario.re_alteracao
                      ? " - RE " + funcionario.re_alteracao
                      : " - sincronização")
                  }}
                </template>
                <template v-else> dd/mm/yyyy </template>
              </b-input-group-text>
            </b-col>

            <!--
              <b-col cols="3">
                <label for="input-live">DATA ALTERAÇÃO</label>                 
                <b-input-group-text >{{moment(funcionario.dt_alteracao).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') }}</b-input-group-text>
              </b-col> 
-->
            <b-col cols="2">
              <label for="input-status">CNH CATEGORIA</label>
              <div>
                <b-form-select
                  v-model="funcionario.id_cnh"
                  required
                  :options="cnhs"
                  class="mb-3"
                  text-field="categoria"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2">
              <label for="input-admissao">CNH EMISSÃO</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="funcionario.dt_cnh_emissao"
                required
                placeholder=" emissão cnh"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="">
              <label for="input-admissao">CNH VALIDADE</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="funcionario.dt_cnh_validade"
                required
                placeholder="vencto cnh"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>
          </b-row>

          <b-button
            class="mt-3"
            variant="success"
            block
            @click="postFuncionarios()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valorefu = [];
      valorefu = this.funcionarios.filter((item) => {
        const registro = item.registro || ""; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
        const cpf = item.cpf || "";
        const versao = item.versao_app || "";
        return (
          registro.indexOf(this.search) > -1 ||
          cpf.indexOf(this.search) > -1 ||
          versao.indexOf(this.search) > -1
        );
      });
      return valorefu;
    },
  },

  name: "FuncionarioCadastro",

  data: function () {
    return {
      value_situacao: [],
      value_empresa: [],
      value_filial: [],

      mode: "save",
      carregando: false,
      atualizando: false,
      empresa: {},
      empresas: [], // [] lista
      filial: {},
      filiais: [], // [] lista
      funcionario: {},
      funcionarios: [],
      funcoes: [],
      situacoes: [],
      cnhs: [],
      page: 1,
      limitfunc: 0,
      count: 0,
      search: "",
      valor_empresa: "",
      selected: null,

      fields: [
        { key: "id_funcionario", label: "id", sortable: true },
        { key: "id_empresa", label: "Empresa", sortable: true },
        { key: "id_filial_erp", label: "Filial", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "nome_completo", label: "Nome", sortable: true },
        { key: "funcao", label: "Função", sortable: true },
        { key: "cpf", label: "CPF", sortable: true },
        { key: "celular", label: "Celular", sortable: true },
        { key: "situacao", label: " Situação", sortable: true },
        { key: "versao_app", label: "Versão", sortable: true },
        {
          key: "dt_admissao",
          label: "Data Admissão",
          sortable: true,
          formatter: (value, key, funcionarios) => {
            return moment(funcionarios.dt_admissao)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: "Data alteração",
          sortable: true,
          formatter: (value, key, funcionarios) => {
            return moment(funcionarios.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },

  methods: {
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    loadEmpresa() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliais() {
      let params = {
        id_empresa:
          this.value_empresa.length > 0
            ? this.value_empresa.map((e) => e.id_empresa).join(",")
            : this.user.id_empresa, // Verifica se há empresas e junta os ids como string
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((fil) => {
            return { ...fil, value: fil.id_filial_erp, filial: fil.filial }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadFuncionarioSituacao() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/folha/funcionario/situacao`;
      axios
        .get(url, { params })
        .then((res) => {
          this.situacoes = res.data;
        })
        .catch(showError);
    },

    loadFuncoes() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/folha/funcionario/funcao`;
      axios
        .get(url, { params })
        .then((res) => {
          this.funcoes = res.data.map((func) => {
            return { ...func, value: func.id_funcao_erp, funcao: func.funcao }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadSituacao() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/folha/funcionario/situacao`;
      axios
        .get(url, { params })
        .then((res) => {
          this.situacoes = res.data.map((sit) => {
            return { ...sit, value: sit.id_situacao, situacao: sit.situacao }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadCnh() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/folha/funcionario/cnh`;
      axios
        .get(url, { params })
        .then((res) => {
          this.cnhs = res.data.map((cnh) => {
            return { ...cnh, value: cnh.id_cnh, categoria: cnh.categoria }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    putFunc(funcionario) {
      this.funcionario = { ...funcionario };
    },

    loadFuncionarios() {
      this.isLoading = true; // Ative o indicador de carregamento
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
        empresa_id: `${this.value_empresa.map((e) => e.id_empresa)}`,
        id_filial: `${this.value_filial.map((f) => f.id_filial_erp)}`,
        id_situacao: `${this.value_situacao.map((s) => s.id_situacao)}`,
        page: `${this.page}`,
      };
      const url = `${baseApiUrl}/folha/funcionario/listagem`;
      axios.get(url, { params }).then((res) => {
        this.funcionarios = res.data.data;
        this.isLoading = false; // Desative o indicador de carregamento
        this.count = res.data.count;
        this.limitfunc = res.data.limitfunc;
      });
    },

    postFuncionarios() {
      let corpo = {
        id_funcionario: `${this.funcionario.id_funcionario}`,
        id_grupo: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.funcionario.id_empresa}`,
        nome: `${this.funcionario.nome_completo}`,
        registro: `${this.funcionario.registro}`,
        id_funcionario_erp:
          this.funcionario.id_funcionario_erp == null
            ? `${this.funcionario.id_funcionario}`
            : `${this.funcionario.id_funcionario_erp}`,
        id_funcao_erp: `${this.funcionario.id_funcao_erp}`,
        id_cnh: `${this.funcionario.id_cnh}`,
        cpf: `${this.funcionario.cpf}`,
        celular: `${this.funcionario.celular}`,
        email: `${this.funcionario.email}`,
        rfid: `${this.funcionario.rfid}`,
        dt_admissao: `${this.funcionario.dt_admissao}`,
        dt_demissao: `${this.funcionario.dt_demissao}`,
        id_situacao: `${this.funcionario.id_situacao}`,
        dt_cnh_emissao: `${this.funcionario.dt_cnh_emissao}`,
        dt_cnh_validade: `${this.funcionario.dt_cnh_validade}`,
        id_funcionario_cadastro: `${this.user.id_funcionario}`,
        id_funcionario_alteracao: `${this.user.id_funcionario}`,
        dt_nascimento: `${this.funcionario.dt_nascimento}`,
        id_sexo: `${this.funcionario.id_sexo}`,
        pis: `${this.funcionario.pis}`,
        id_empresa_erp:
          this.funcionario.id_empresa_erp == null
            ? `${this.funcionario.id_empresa}`
            : `${this.funcionario.id_empresa_erp}`,
        id_filial_erp: `${this.funcionario.id_filial_erp}`,
        foto_url: `${this.funcionario.foto_url}`,
        chapa: `${this.funcionario.chapa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/folha/funcionario`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess(), this.reset(); //limpar os objetos valores
        })
        .catch(showError);
    },

    reset() {
      //    this.funcionario = {}
      this.loadFuncionarios();
    },
  },

  watch: {
    page() {
      this.loadFuncionarios();
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadFuncionarios();
    this.loadFiliais();
    this.loadSituacao();
    this.loadFuncoes();
    this.loadCnh();
    this.putFunc();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
#selecaostatusx {
  font-size: 0.7em;
}
</style>
